/**
 * Formats published articles count with Russian pluralization.
 */
export function formatArticlesCount(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return `${count} статья`;
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${count} статьи`;
  }
  return `${count} статей`;
}
